import * as types from './constants';

// Get Merchants
export const getMerchantsRequest = data => (
  { type: types.GET_MERCHANTS_REQUEST, payload: data }
);

export const getMerchantsDone = data => (
  { type: types.GET_MERCHANTS_DONE, payload: data }
);

export const getMerchantsFailed = errors => (
  { type: types.GET_MERCHANTS_FAILED, payload: errors }
);

// Delete Merchant
export const deleteMerchantRequest = data => (
  { type: types.DELETE_MERCHANT_REQUEST, payload: data }
);

export const deleteMerchantDone = () => (
  { type: types.DELETE_MERCHANT_DONE }
);

export const deleteMerchantFailed = errors => (
  { type: types.DELETE_MERCHANT_FAILED, payload: errors }
);

// Operations
export const merchantsSetPage = data => (
  { type: types.MERCHANTS_SET_PAGE, payload: data }
);